import { IDropdownOption } from '@fluentui/react';

export const TIME_FRAMES: IDropdownOption[] = [
  {
    key: 'custom',
    text: 'Custom',
  },
  {
    key: 'last-week',
    text: 'Last Week',
  },
  {
    key: 'week-to-date',
    text: 'Week to Date',
  },
  {
    key: 'last-month',
    text: 'Last Month',
  },
  {
    key: 'month-to-date',
    text: 'Month to Date',
  },
  {
    key: 'last-quarter',
    text: 'Last Quarter',
  },
  {
    key: 'quarter-to-date',
    text: 'Quarter to Date',
  },
  {
    key: 'last-year',
    text: 'Last Year',
  },
  {
    key: 'year-to-date',
    text: 'Year to Date',
  },
];
